import "@/App.css";
import { ScoundrelScout } from "@/components/ScoundrelScout";

function App() {
  return <ScoundrelScout />;
}

export default App;
